// extracted by mini-css-extract-plugin
export var banner = "_1e-0";
export var icon = "_1e-1";
export var message = "_1e-2";